import type { ReactNode } from 'react';
import { Box } from '@mui/material';
import { Panel } from '../../../../shared/ui/panel/panels';
import { PrimaryTitleGray } from '../../../../app/theme/tokens/colors';

/** Apresentação compartilhada; consultas e criação de pedidos pertencem ao chamador. */
export const FinishOrderLayout = ({
  summary,
  delivery,
  equipment,
  notes,
  embedded = false,
  title = 'Resumo do pedido',
}: {
  summary: ReactNode;
  delivery: ReactNode;
  equipment: ReactNode;
  notes?: ReactNode;
  embedded?: boolean;
  title?: string;
}) => {
  const panelStyle = embedded
    ? {
        minWidth: 0,
        border: '1px solid #dce5de',
        boxShadow: 'none',
        borderRadius: 8,
      }
    : {};
  return (
    <Box sx={{ p: embedded ? 0 : '10px', minWidth: 0 }}>
      <h3
        style={{
          color: PrimaryTitleGray,
          margin: embedded ? '0 0 12px' : '10px 15px',
        }}
      >
        {title}
      </h3>
      {summary}
      <Box
        className="default-finish-order"
        sx={
          embedded
            ? {
                display: 'grid',
                gridTemplateColumns: {
                  xs: 'minmax(0, 1fr)',
                  md: 'minmax(0, 1fr) minmax(0, 2fr)',
                },
                gap: 2,
                mb: 0,
                alignItems: 'start',
              }
            : undefined
        }
      >
        <Panel
          className="delivery-configuration"
          style={
            embedded ? { ...panelStyle, margin: 0, padding: 16 } : undefined
          }
        >
          {delivery}
        </Panel>
        <div className="right-panels" style={{ flex: 3, minWidth: 0 }}>
          <Panel
            className="delivery-description"
            style={{
              ...panelStyle,
              marginBottom: notes ? 10 : 0,
              flex: 3,
              padding: embedded ? 16 : 20,
              boxSizing: 'border-box',
              height: notes ? 'auto' : '100%',
            }}
          >
            {equipment}
          </Panel>
          {notes && (
            <Panel
              className="delivery-details"
              style={{
                ...panelStyle,
                padding: embedded ? 16 : 20,
                boxSizing: 'border-box',
              }}
            >
              {notes}
            </Panel>
          )}
        </div>
      </Box>
    </Box>
  );
};
